document.addEventListener('DOMContentLoaded', function () {
  function getCard(element) {
    return element.closest('[data-product-id]');
  }

  function getQuickAddButton(card) {
    return card ? card.querySelector('[data-quick-add]') : null;
  }

  function getSizeButtons(card) {
    return card ? Array.from(card.querySelectorAll('[data-size-option]')) : [];
  }

  function getInventoryQuantity(button) {
    return Number(button.getAttribute('data-variant-quantity') || '0');
  }

  function getInventoryManaged(button) {
    return button.getAttribute('data-variant-inventory-management') === 'true';
  }

  function getInventoryPolicy(button) {
    return button.getAttribute('data-variant-inventory-policy') || 'deny';
  }

  function getVariantId(button) {
    return Number(button.getAttribute('data-variant-id') || '0');
  }

  function getRawAvailable(button) {
    return button.getAttribute('data-available') !== 'false';
  }

  function isButtonAvailable(button, cartVariantMap) {
    if (!button) return false;

    const rawAvailable = getRawAvailable(button);
    if (!rawAvailable) return false;

    const variantId = getVariantId(button);
    const inCartQty = cartVariantMap ? cartVariantMap.get(variantId) || 0 : 0;
    const inventoryManaged = getInventoryManaged(button);
    const inventoryPolicy = getInventoryPolicy(button);
    const inventoryQty = getInventoryQuantity(button);

    if (inventoryManaged && inventoryPolicy !== 'continue') {
      return inventoryQty - inCartQty > 0;
    }

    return true;
  }

  function markButtonAvailability(button, available) {
    if (!button) return;

    if (available) {
      button.classList.remove('is-disabled');
      button.disabled = false;
      button.setAttribute('data-available', 'true');
    } else {
      button.classList.add('is-disabled');
      button.disabled = true;
      button.setAttribute('data-available', 'false');
      button.classList.remove('is-selected');
    }
  }

  function setQuickAddState(quickAddButton, variantId, available) {
    if (!quickAddButton) return;

    if (variantId) {
      quickAddButton.setAttribute('data-variant-id', String(variantId));
    } else {
      quickAddButton.removeAttribute('data-variant-id');
    }

    if (available) {
      quickAddButton.disabled = false;
      quickAddButton.classList.remove('is-sold-out');
      quickAddButton.setAttribute('data-available', 'true');
    } else {
      quickAddButton.disabled = true;
      quickAddButton.classList.add('is-sold-out');
      quickAddButton.setAttribute('data-available', 'false');
    }
  }

  function setSelectedSize(card, selectedButton, cartVariantMap) {
    const quickAddButton = getQuickAddButton(card);
    const sizeButtons = getSizeButtons(card);

    if (!card || !quickAddButton) return;

    if (!sizeButtons.length) {
      const variantId = getVariantId(quickAddButton);
      const available = cartVariantMap
        ? isButtonAvailable(quickAddButton, cartVariantMap)
        : getRawAvailable(quickAddButton);

      setQuickAddState(quickAddButton, variantId, available);
      return;
    }

    sizeButtons.forEach(function (button) {
      button.classList.remove('is-selected');
    });

    if (!selectedButton || selectedButton.disabled) {
      selectedButton = sizeButtons.find(function (button) {
        return cartVariantMap ? isButtonAvailable(button, cartVariantMap) : !button.disabled;
      });
    }

    if (!selectedButton) {
      setQuickAddState(quickAddButton, '', false);
      return;
    }

    const variantId = getVariantId(selectedButton);
    const available = cartVariantMap
      ? isButtonAvailable(selectedButton, cartVariantMap)
      : getRawAvailable(selectedButton);

    selectedButton.classList.add('is-selected');
    setQuickAddState(quickAddButton, variantId, available);
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch cart');
    }

    return response.json();
  }

  function buildCartVariantMap(cart) {
    const map = new Map();

    if (!cart || !cart.items) return map;

    cart.items.forEach(function (item) {
      const variantId = Number(item.variant_id);
      const qty = Number(item.quantity || 0);

      if (!variantId) return;
      map.set(variantId, (map.get(variantId) || 0) + qty);
    });

    return map;
  }

  function syncCardAvailabilityFromCart(card, cartVariantMap) {
    const sizeButtons = getSizeButtons(card);
    const quickAddButton = getQuickAddButton(card);

    if (!card || !quickAddButton) return;

    if (!sizeButtons.length) {
      const currentVariantId = getVariantId(quickAddButton);
      const available = isButtonAvailable(quickAddButton, cartVariantMap);
      setQuickAddState(quickAddButton, currentVariantId, available);
      return;
    }

    sizeButtons.forEach(function (button) {
      const available = isButtonAvailable(button, cartVariantMap);
      markButtonAvailability(button, available);
    });

    const selectedButton = card.querySelector('[data-size-option].is-selected');
    setSelectedSize(card, selectedButton, cartVariantMap);
  }

  async function syncAllCardsWithCart(scope) {
    const root = scope || document;
    const cards = root.querySelectorAll('[data-product-id]');

    if (!cards.length) return;

    try {
      const cart = await fetchCart();
      const cartVariantMap = buildCartVariantMap(cart);

      cards.forEach(function (card) {
        syncCardAvailabilityFromCart(card, cartVariantMap);
      });

      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Cart sync error:', error);
    }
  }

  function initCardSizes(scope) {
    const root = scope || document;
    const cards = root.querySelectorAll('[data-product-id]');

    cards.forEach(function (card) {
      const quickAddButton = getQuickAddButton(card);
      const sizeButtons = getSizeButtons(card);

      if (!quickAddButton) return;
      if (card.dataset.sizesInitialized === 'true') return;

      card.dataset.sizesInitialized = 'true';

      if (sizeButtons.length) {
        let selectedButton = card.querySelector('[data-size-option].is-selected');

        if (!selectedButton || selectedButton.disabled) {
          selectedButton = sizeButtons.find(function (button) {
            return !button.disabled;
          });
        }

        setSelectedSize(card, selectedButton);

        sizeButtons.forEach(function (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (button.disabled) return;
            setSelectedSize(card, button);
          });
        });
      } else {
        const variantId = quickAddButton.getAttribute('data-variant-id');
        const available = quickAddButton.getAttribute('data-available') === 'true';
        setQuickAddState(quickAddButton, variantId, available);
      }
    });
  }

  async function refreshCartCount() {
    try {
      const cart = await fetchCart();

      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Cart refresh error:', error);
    }
  }

  async function refreshCartDrawer() {
    if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
      await window.CartDrawer.refresh();
    }
  }

  function openCartDrawer() {
    if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
      window.CartDrawer.open();
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  async function handleQuickAdd(button, event) {
    event.preventDefault();
    event.stopPropagation();

    const card = getCard(button);
    const variantId = Number(button.getAttribute('data-variant-id') || '0');

    if (!variantId) return;
    if (button.classList.contains('is-loading')) return;
    if (button.disabled) return;

    button.classList.add('is-loading');
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!response.ok) {
        if (response.status === 422) {
          await syncAllCardsWithCart(document);
          throw new Error('Variant sold out');
        }

        throw new Error('Add to cart failed');
      }

      await response.json();

      await refreshCartCount();
      await refreshCartDrawer();
      await syncAllCardsWithCart(document);

      button.blur();
      openCartDrawer();
    } catch (error) {
      console.error('Add to cart error:', error);
    } finally {
      button.classList.remove('is-loading');

      if (card) {
        const selectedButton = card.querySelector('[data-size-option].is-selected');

        if (selectedButton) {
          button.disabled = selectedButton.disabled;
        } else {
          const available = button.getAttribute('data-available') === 'true';
          button.disabled = !available;
        }
      } else {
        const available = button.getAttribute('data-available') === 'true';
        button.disabled = !available;
      }
    }
  }

  function bindQuickAddButtons(scope) {
    const buttons = (scope || document).querySelectorAll('[data-quick-add]');

    buttons.forEach(function (button) {
      if (button.dataset.quickAddBound === 'true') return;

      button.dataset.quickAddBound = 'true';

      button.addEventListener('click', function (event) {
        handleQuickAdd(button, event);
      });
    });
  }

  function initProductCardCart(scope) {
    initCardSizes(scope || document);
    bindQuickAddButtons(scope || document);
    syncAllCardsWithCart(scope || document);
  }

  window.initProductCardCart = initProductCardCart;
  window.syncProductCardCart = function (scope) {
    syncAllCardsWithCart(scope || document);
  };

  initProductCardCart(document);

  window.addEventListener('pageshow', function () {
    initProductCardCart(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProductCardCart(event.target);
  });
});